/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WindowSize } from '../WindowSize.js';
import { useNavigate } from 'react-router-dom';
import { GetUrl, CTicksToDateString, formatNumber } from '../Utility.js';

import Title from './Title.js';
import DetailModalType1 from './DetailModalType1.js'
import WriteModalType from './WriteModalType.js'

function Terms() {
  const state=useSelector((state)=>state);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 

    const RequestTermList = async () => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            }
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Admin/AdminGetTermsList', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    dispatch({type:'UpdateTermsArray', Log:data.data_array});  
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                var startTime = CTicksToDateString(data.start_time);
                var endTime = CTicksToDateString(data.end_time);

                var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                alert(message);  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };  

  function GetTermsClick(index)
  {
      if(state.TermsArray === undefined || state.TermsArray.length <= index)
      {
          return false;
      }

      return true;
  }

  function TermsClick(index)
  {
      if(state.TermsArray === undefined || state.TermsArray.length <= index)
      {
          return;
      }

      dispatch({type:'UpdateDetailModalType1', View:true, Type:4, No:state.terms_data_array[index].no});
  }

  function GetTermsNo(index)
  {
      if(state.TermsArray === undefined || state.TermsArray.length <= index)
      {
          return "";
      }

      return index + 1;
  }

  function GetTermsTitle(index)
  {
      if(state.TermsArray === undefined || state.TermsArray.length <= index)
      {
          return "";
      }

      return state.TermsArray[index].title;
  }

  function GetTermsRegisterTime(index)
  {
      if(state.TermsArray === undefined || state.TermsArray.length <= index)
      {
          return "";
      }

      return CTicksToDateString(state.TermsArray[index].create_at_time);
  }

    const RequestDelete = async (index) => 
    {
        if(window.confirm(state.TermsArray[index].title + " 정말로 삭제 하시겠습니까?")) {
            try
            {
                if(state.Request === 1)
                {
                    return;
                }

                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                    return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'Admin/AdminDeleteTerms', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, no : state.TermsArray[index].no}),
                });

                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {

                    }
                    else if(data.result === 14 ||
                            data.result === 16)
                    {
                        alert('존재 하지 않는 티켓 입니다');  
                    }
                    else if(data.result === 15)
                    {
                        alert('이미 사용한 티켓 입니다');  
                    }
                    else if(data.result === 3 ||
                            data.result === 1)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                        var startTime = CTicksToDateString(data.start_time);
                        var endTime = CTicksToDateString(data.end_time);
        
                        var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                        alert(message);  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                } 
                else
                {
                    alert('Network Fail');
                }

                dispatch({type:'Response'});

                RequestTermList();
            }
            catch(error)
            {
                alert('Network Fail');
                dispatch({type:'Response'});
                console.error(error);
            }
        }
    }

  function WriteModal()
  {
    if(state.TermsArray.length === 10)
    {
        alert('10개 이상 등록 할 수 없습니다다. 삭제 후 등록 해주세요');
        return;
    }

    dispatch({type:'UpdateWriteModal', View:true, Type:4});
  }

  const closeDetailModalType1 = () => {
    dispatch({type:'UpdateDetailModalType1', View:false, Type:0, No:0});
  }

  const closeWriteModalType = (refresh) => {
    dispatch({type:'UpdateWriteModal', View:false, Type:0});
    if(refresh === true)
    {
        RequestTermList();
        dispatch({type:'RefreshTerms', Refresh:false});
    }
  }

  if(state.TermsFirstRender === false)
    {
        dispatch({type:'TermsFirstRender'});
        RequestTermList();
    }  

  return (
    <div id='Player_Range'>
        <Title DisplayType="8"></Title>
        <div className='search-box'>
            <div className='search_button' onClick={() => WriteModal()}>글쓰기</div>
        </div>
        <div className='terms-box'>
            <div className='terms-box-table'>
                <tr>
                    <th style={{width:"5%"}}>넘버</th>
                    <th style={{width:"10%"}}>제목</th>
                    <th style={{width:"10%"}}>작성일</th>
                    <th style={{width:"10%"}}>삭제</th>
                </tr>
                {Array.from({length:10}).map((_, index)=>(
                    <tr>
                        <td onClick={() => GetTermsClick(index) === true && TermsClick(index)} style={{cursor: GetTermsClick(index) === true ? 'pointer' : 'default', width:"200px", textAlign:"center"}}>{GetTermsNo(index)}</td>
                        <td onClick={() => GetTermsClick(index) === true && TermsClick(index)} style={{cursor: GetTermsClick(index) === true ? 'pointer' : 'default', width:"600px", textAlign:"center"}}>{GetTermsTitle(index)}</td>
                        <td onClick={() => GetTermsClick(index) === true && TermsClick(index)} style={{cursor: GetTermsClick(index) === true ? 'pointer' : 'default', width:"300px", textAlign:"center"}}>{GetTermsRegisterTime(index)}</td>
                        <td>
                        {GetTermsClick(index) === true &&
                          <div className='terms-button-group'>
                            <div className='terms-delete-button' onClick={() => RequestDelete(index)}>삭제</div>
                          </div>}
                        </td>
                    </tr>
                ))}
            </div>
        </div>
        <DetailModalType1 isOpen={state.detail_modal_type1_open} Type={state.detail_modal_type1_type} No={state.detail_modal_type1_no} onClose={closeDetailModalType1} ></DetailModalType1>
        <WriteModalType isOpen={state.write_modal_open} onClose={closeWriteModalType}></WriteModalType>
    </div>
  );
}

export default Terms;